import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorYahoo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 41 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#5F01D1"
      d="M0 9.757h2.43l1.414 3.619 1.433-3.62h2.365l-3.561 8.568H1.7l.974-2.27L0 9.757ZM10.106 9.613c-1.825 0-2.979 1.637-2.979 3.267 0 1.834 1.265 3.289 2.945 3.289 1.252 0 1.725-.764 1.725-.764V16h2.118V9.757h-2.118v.567s-.527-.711-1.69-.711Zm.45 2.006c.843 0 1.278.666 1.278 1.268 0 .647-.466 1.283-1.277 1.283-.672 0-1.28-.55-1.28-1.256 0-.716.489-1.295 1.28-1.295ZM14.645 16V7h2.216v3.346s.526-.733 1.629-.733c1.348 0 2.138 1.005 2.138 2.441V16h-2.2v-3.405c0-.486-.231-.956-.755-.956-.534 0-.812.477-.812.956V16h-2.216ZM24.407 9.613c-2.09 0-3.335 1.59-3.335 3.293 0 1.938 1.507 3.263 3.343 3.263 1.78 0 3.337-1.265 3.337-3.23 0-2.151-1.63-3.326-3.345-3.326Zm.02 2.024c.739 0 1.25.615 1.25 1.271 0 .56-.477 1.25-1.25 1.25-.708 0-1.24-.569-1.24-1.256 0-.662.442-1.265 1.24-1.265ZM31.444 9.613c-2.09 0-3.335 1.59-3.335 3.293 0 1.938 1.507 3.263 3.343 3.263 1.78 0 3.337-1.265 3.337-3.23 0-2.151-1.63-3.326-3.345-3.326Zm.02 2.024c.739 0 1.25.615 1.25 1.271 0 .56-.477 1.25-1.25 1.25-.708 0-1.24-.569-1.24-1.256 0-.662.442-1.265 1.24-1.265ZM36.538 16.133a1.472 1.472 0 1 0 0-2.944 1.472 1.472 0 0 0 0 2.944ZM38.493 12.649h-2.65L38.196 7h2.64l-2.342 5.649Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorYahoo)
export default ForwardRef
